
export default {
  name: 'home',
  components: {

  },
  data() {
    return {

    	paymentState: {
        0: '不需要支付',
        1: '支付成功',
        2: '账户入账成功',
        3: '等待打款',
        4: '打款失败-已退回余额'
      },
      list: [],
      navs: [],
      params: {
        pageNumber: 1,
        pageSize: 20,
        state: ''
      },
      states: {},
      lastPage: false,
      checkPageNumber:1,
    }
  },
  created() {
  },
  mounted: function () {
    // this.getNavs()
    this.params.state = this.$route.query.id || ''
    this.getList()
  },
  methods: {
    changeTable: function(state) {
      this.params.state = state
      this.params.pageNumber = 1
      this.lastPage = false
      this.list = []
      this.getList()
    },
    load() {
      setTimeout(d => {
        this.getList()
      }, 100)
    },
    toHb: function () {
      this.$message('正在开发')
    },
    toLinks: function () {
      this.$router.push({ path: '/links' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toMy: function () {
      this.$router.push({ path: '/my' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toBindAli: function () {
      this.$router.push({ path: '/bindAli' })
    },

    toList: function () {
      this.$router.push({ path: '/list' })
    },
    getNavs: function () {
      this.apiGet('/h5/api/user/orderStateList', '', res => {
        if (res.state) {
          res.data.forEach(d => {
            this.states[d.state] = d.size
          })
          this.$forceUpdate()
          console.log('this.states', this.states)
        } else {
          this.$message(res.msg)
        }
      })
    },
    backPage: function() {
      window.history.go(-1)
    },
    getList: function () {
      if (this.lastPage) {
        return
      }
      this.apiGet('/h5/api/user/orderList', this.params, res => {
        this.lastPage = true;
        if (res.state) {
          this.params.pageNumber++;
          this.list = this.list.concat(res.data.list)
          setTimeout(d=>{
            this.lastPage = res.data.lastPage;
          },500)
        } else {
          // this.$message(res.msg);
        }
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/list/list.js